import { TPosition, TSize } from './interface';

export const SIZE: Record<string, TSize> = {
  DEFAULT: 'default',
  SMALL: 'small',
  LARGE: 'large',
};

export const POSITION: Record<string, TPosition> = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
};
